import { useTranslation } from "react-i18next";
import FooterLogo from "../../components/footer-logo";
import ReactGA from "react-ga4";

const Footer = () => {
    const { t } = useTranslation();
    const trackLinkClick = (label) => {
        ReactGA.event({
            category: "User Interaction",
            action: "Clicked Contact Link",
            label: label,
        });
    };
    return (
        <footer className="footer-area reveal-footer border-top-style">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="footer-content">
                            <div className="widget-item">
                                <div className="widget-copyright">
                                    <p>
                                        © Copyright {new Date().getFullYear()}{" "}
                                        lipkovska.art
                                    </p>
                                </div>
                            </div>
                            <div className="widget-item text-center">
                                <div className="about-widget">
                                    <FooterLogo
                                        image={`${process.env.PUBLIC_URL}/img/logo.png`}
                                    />
                                </div>
                            </div>
                            <div className="widget-item">
                                <ul className="widget-social">
                                    <li className="social-text">
                                        <span>{t("social.title")}</span>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.facebook.com/lipkovska.art/"
                                            onClick={() =>
                                                trackLinkClick(
                                                    "Facebook from Footer"
                                                )
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="social_facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.instagram.com/viktoriia_lipkovska/"
                                            onClick={() =>
                                                trackLinkClick(
                                                    "Instagram from Footer"
                                                )
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="social_instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
